export const MAINTENANCE_MODE_FLAG = 'gxgo-maintenance-mode-enabled';
export const PERSONALIZATION_FLAG = 'gxgo-personalization-enabled';
export const GX_AI_FLAG = 'gxgo-ai-chat-enabled';
export const GX_PROMPT_SHARE = 'gxgo-ai-prompt-share-enabled';
export const GX_EXPORT_VIDEO_EXPLAINER = 'gxgo-export-video-explainer';
export const GX_MONTHLY_RECAP_MODAL = 'gxgo-monthly-recap-modal-enabled';
export const DATA_SCIENCE_PROTOTYPES_FLAG = 'gxgo-data-science-prototypes-enabled';
